//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouse'
import Translator from '@/services/translator'

//
import TransferBetweenWarehouseFields, {
    CloseTransferBetweenWarehouseFields,
} from './fields'

//
export default {
    name: 'transfer-between-warehouse-update',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', {
            user: 'user',
        }),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        canEdit() {
            return (
                this.$can('EDIT_TRANSFER_BETWEEN_WAREHOUSE') &&
                this.formData.can_edit
            )
        },

        /**
         *
         */
        dialogFormProps() {
            return {
                fields: CloseTransferBetweenWarehouseFields,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: TransferBetweenWarehouseFields({
                    g_branch_office_id: this.branchOfficeId,
                    triggerWarehouse: this.changeWarehouseFilter,
                }),
                loading: this.formBusy,
                switchEdit: this.canEdit,
            }
        },

        /**
         *
         */
        formTitle() {
            return `Guiá de intercambio #${this.$route.params.id}`
        },
    },
    data() {
        return {
            dialog: false,
            branchOfficeId: 1,
            formBusy: false,
            formData: {
                wh_selected_products: [],
            },
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
            setErrorSnackbar: 'setErrorSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                Translator(TransferBetweenWarehouseModel, error.response.data)
            )
        },

        /**
         *
         */
        errorClose() {
            this.setErrorSnackbar('Código de autorización invalido.')
        },

        /**
         *
         */
        fetch() {
            return TransferBetweenWarehouseModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
                .then(this.setFormBusy)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'transfer-between-warehouse' })
        },

        /**
         *
         */
        reset() {
            this.setFormBusy(true).then(this.fetch)
        },

        /**
         *
         */
        async setFormBusy(formBusy = false) {
            this.formBusy = formBusy
        },

        /**
         *
         */
        setFormData(model) {
            this.branchOfficeId = this.user.hr_employee.g_branch_office_id
            this.formData = model.reset({ user: this.user })
        },

        /**
         *
         */
        successClose() {
            this.setSuccessSnackbar('Guía de intercambio cerrada exitosamente.')
            this.reset()
            this.dialog = false
        },

        /**
         *
         */
        successUpdate() {
            this.setSuccessSnackbar(
                'Guía de intercambio actualizada exitosamente.'
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        submitClose() {
            this.$refs.formClose
                .setWait(true)
                .then(this.toClose)
                .then(this.$refs.formClose.setWait)
        },

        /**
         *
         */
        submitUpdate(event) {
            if (event.wh_from_warehouse_id !== event.wh_to_warehouse_id) {
                this.$refs.formUpdate
                    .setWait(true)
                    .then(this.toUpdate)
                    .then(this.$refs.formUpdate.setWait)
            } else {
                this.showSnackbar(
                    'error',
                    'Advertencia.',
                    'Las bodegas deben ser distintas.'
                )
            }
        },

        /**
         *
         */
        toClose(model) {
            return model
                .close()
                .attach(model.toClose())
                .then(this.successClose)
                .catch(this.errorClose)
        },

        /**
         *
         */
        toUpdate(model) {
            return model
                .update()
                .then(this.successUpdate)
                .catch(this.error)
        },
    },
    watch: {
        'formData.wh_selected_products'(value) {
            if (value.length > 24) {
                this.formData.wh_selected_products = value.slice(0, 24)
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_TRANSFER_BETWEEN_WAREHOUSE'))
                ctx.$router.push('/')
        })
    },
    beforeMount() {
        this.setTitleTopBar(this.formTitle)
    },
    mounted() {
        this.reset()
    },
}
